var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRangeHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 2C24.6264 2 27.2272 2.51732 29.6537 3.52241C32.0802 4.5275 34.285 6.00069 36.1421 7.85787C37.9993 9.71504 39.4725 11.9198 40.4776 14.3463C41.4827 16.7728 42 19.3736 42 22L22 22V2Z",
    fill: "#EB0000",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 22C42 24.6264 41.4827 27.2272 40.4776 29.6537C39.4725 32.0802 37.9993 34.285 36.1421 36.1421C34.285 37.9993 32.0802 39.4725 29.6537 40.4776C27.2272 41.4827 24.6264 42 22 42L22 22L42 22Z",
    fill: "#EB0000",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 42C19.3736 42 16.7728 41.4827 14.3463 40.4776C11.9198 39.4725 9.71503 37.9993 7.85786 36.1421C6.00069 34.285 4.5275 32.0802 3.52241 29.6537C2.51732 27.2272 2 24.6264 2 22L22 22L22 42Z",
    fill: "#EB0000",
    fillOpacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22C2 19.3736 2.51731 16.7728 3.52241 14.3463C4.5275 11.9198 6.00069 9.71503 7.85786 7.85786C9.71504 6.00069 11.9198 4.5275 14.3463 3.52241C16.7728 2.51731 19.3736 2 22 2L22 22L2 22Z",
    fill: "#EB0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRangeHigh);
export default __webpack_public_path__ + "static/media/icon_range_high.07561b97c6d020252097b025afac3c2c.svg";
export { ForwardRef as ReactComponent };